import { TextField, Typography, Button } from "@mui/material";
import { maskCpfCnpj, maskBirthDate, validateCpfCnpj } from "utils/Masks/Masks";
import { useContext } from "react";
import ApiContext from "api";
import { useState } from "react";
import { toast } from "react-toastify";
import IndustrialAccess from "./IndustrialAccess";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { AuthService } from "context/AuthContext/AuthContext";
import ClienteService from "services/cliente";
import HelpModal from "components/DataDisplay/HelpModal/HelpModal";

const getSerproErrorMessage = (error) => {
  const fallback =
    "Não foi possível completar o cadastro, entre em contato com o suporte.";

  const mensagem =
    typeof error === "string" ? error : error?.mensagem || error?.message;

  if (!mensagem || typeof mensagem !== "string") return fallback;

  try {
    const parsed = JSON.parse(mensagem);
    if (parsed?.erro === "DATA_NASCIMENTO_DIVERGENTE")
      return parsed.erroDescricao || "Data de nascimento não confere.";
  } catch (e) {
    // mensagem já é um texto legível, não um envelope JSON
  }

  return mensagem;
};

export default function LoginStepCpfCnpj({ onSuccessConsultCpfCnpj }) {
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [isCpfcnpjValid, setIsCpfcnpjValid] = useState(false);
  const [isIndustrial, setIsIndustrial] = useState(false);
  const [isLicitacao, setIsLicitacao] = useState(false);
  const [userDataConsulta, setUserDataConsulta] = useState(null);
  const [birthDate, setBirthDate] = useState("");
  const [isNewClient, setIsNewClient] = useState(false);

  const router = useHistory();

  const { ConsigazApi } = useContext(ApiContext);
  const featureFlagNovaFormaAcessoContaSim = process.env.REACT_APP_FLAG_NOVA_FORMA_ACESSO_CONTASIM === "true";
  const featureFlagNovaFormaAcessoIndustrial = process.env.REACT_APP_FLAG_NOVA_FORMA_ACESSO_INDUSTRIAL === "true";
  const featureFlagNovaFormaAcesso = featureFlagNovaFormaAcessoContaSim || featureFlagNovaFormaAcessoIndustrial;
  const [openHelpModal, setOpenHelpModal] = useState(false);

  const handleValidateCpfCnpj = async (normalizedCpfCnpj, birthDateValue = "") => {
    const cleanBirthDate = birthDateValue.replace(/\D/g, "");

    try {
      const serproResponse = await ConsigazApi.validateCpfCnpj(
        normalizedCpfCnpj,
        cleanBirthDate
      );
      const {
        nome,
        situacao,
        situacaoCadastral,
        nomeEmpresarial,
        nomeFantasia,
      } = serproResponse;
      const isRegular =
        situacao?.codigo === "0" || situacaoCadastral?.codigo === "2";

      if (!situacao && !situacaoCadastral) {
        return toast.error(
          "Não foi possível identificar a situação do CPF/CNPJ informado."
        );
      }

      if (!isRegular) {
        return toast.error(
          `Não foi possível cadastrar o cliente, situação do CPF/CNPJ: ${
            situacao?.descricao || situacaoCadastral?.motivo
          }`
        );
      }

      const isCnpj = normalizedCpfCnpj.length > 11;

      if (!featureFlagNovaFormaAcesso) {
        AuthService.setTokenLocalStorage("Zm9vOmJhcgo=");
        AuthService.setUserCpfLocalStorage(normalizedCpfCnpj);

        ClienteService.newClienteData = {
          cpfcnpj: normalizedCpfCnpj,
          name: isCnpj ? nomeFantasia : nome,
          phoneNumber: "",
          emailAddress: "",
        };
      }

      router.push({
        pathname: featureFlagNovaFormaAcesso ? isCnpj ? "register-industrial" : "/register-client" : "new-client",
        state: featureFlagNovaFormaAcesso ? {
          cpfCnpj: normalizedCpfCnpj,
          existentClient: false,
          nome,
          nomeEmpresarial,
          nomeFantasia,
        } :
        {
          phoneNumber: "",
          isPhoneNumberValid: false,
          emailAddress: "",
          isEmailAddressValid: false,
          name: isCnpj ? nomeFantasia : nome,
          isNameValid: true
        },
      });
    } catch (error) {
      toast.error(getSerproErrorMessage(error));
      setIsNewClient(false);
      setBirthDate("");
    }
  };

  const handleSubmit = async () => {
    if (!isCpfcnpjValid)
      return toast.error(
        "CPF ou CNPJ inválido. Verifique se digitou todos os números corretamente."
      );

    const normalizedCpfCnpj = cpfCnpj
      .replace(/[^0-9A-Za-z]/g, "")
      .toUpperCase();

    if (isNewClient) return handleValidateCpfCnpj(normalizedCpfCnpj, birthDate);

    try {
      const response = await ConsigazApi.consultCpfCnpj(normalizedCpfCnpj);

      const userData = response.RetornoUsuario?.[0];
      const isNotClient = !userData || userData["tipo-conta"] === "";

      setUserDataConsulta(response.RetornoUsuario[0]);

      if (response.RetornoUsuario[0]["tipo-conta"] === "INDUSTRIAL") {
        return setIsIndustrial(true);
      }

      if (response.RetornoUsuario[0]["tipo-conta"] === "LICITACAO") {
        return featureFlagNovaFormaAcessoIndustrial ? setIsLicitacao(true) : setOpenHelpModal(true);
      }

      if (isNotClient) {
        const isCnpj = normalizedCpfCnpj.length > 11;

        if (isCnpj) return handleValidateCpfCnpj(normalizedCpfCnpj);

        return setIsNewClient(true);
      }

      onSuccessConsultCpfCnpj(response.RetornoUsuario[0], normalizedCpfCnpj);
    } catch (error) {
      console.log(error);
    }
  };

  const onBack = () => {
    setIsIndustrial(false);
  };

  return isIndustrial || isLicitacao ? (
    <IndustrialAccess
      onSuccessConsultCpfCnpj={onSuccessConsultCpfCnpj}
      cnpj={cpfCnpj}
      onBack={onBack}
      userDataConsulta={userDataConsulta}
    />
  ) : (
    <>
      <Typography color="#FFFFFF" fontSize={"30px"} fontWeight={700}>
        Olá!
      </Typography>
      <Typography color="#FFFFFF" fontSize={"15px"} mt={2} fullWidth>
        Que bom ter você aqui! Vamos começar!
      </Typography>
      <Typography color="#FFFFFF" fontSize={"15px"} fullWidth>
        Insira abaixo seu CPF ou CNPJ para verificarmos se já possui cadastro em
        nosso sistema.
      </Typography>
      <TextField
        variant="standard"
        color="secondary"
        value={cpfCnpj}
        fullWidth
        disabled={isNewClient}
        onChange={(e) => {
          const maskedCpfcnpj = maskCpfCnpj(e.target.value);
          setIsCpfcnpjValid(validateCpfCnpj(maskedCpfcnpj));
          setCpfCnpj(maskedCpfcnpj);
        }}
        placeholder="000.000.000-00"
        sx={{
          "& input": {
            color: "gray",
          },
          mt: "100px",
        }}
      />

      {isNewClient && (
        <TextField
          variant="standard"
          color="secondary"
          value={birthDate}
          fullWidth
          inputProps={{ maxLength: 10 }}
          onChange={(e) => setBirthDate(maskBirthDate(e.target.value))}
          placeholder="00/00/0000"
          sx={{
            "& input": {
              color: "gray",
            },
            mt: 3,
          }}
        />
      )}

      <HelpModal open={openHelpModal} onClose={() => setOpenHelpModal(false)} />

      <Button
        variant="contained"
        color="secondary"
        sx={{
          height: "45px",
          color: "#fff",
          borderRadius: "36px",
          width: "100%",
          mt: 5,
        }}
        onClick={handleSubmit}
      >
        Avançar
      </Button>
    </>
  );
}
